export default __webpack_public_path__ + "img/f29a1c704c70d5f425e1f7a43f47c912.svg";